/** True on /order, /book, ordering subdomain, or ?view=online|book — no POS soft keyboard. */
export function isPublicGuestOrderingRoute(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const host = window.location.hostname.toLowerCase();
    const path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    const hashQuery = hash.startsWith('#') ? hash.slice(1) : hash;
    return (
      host.startsWith('order.') ||
      path === '/order' ||
      path === '/book' ||
      search.includes('view=online') ||
      search.includes('view=book') ||
      hashQuery.includes('view=online') ||
      hashQuery.includes('view=book')
    );
  } catch {
    return false;
  }
}
